import ReactDOM from "react-dom";
import React, { useRef, useState } from "react";
import Login from "./login/login";
import "../../../../../shared/styles/colorDefinitions.css";
import "../main.css";
import "../../../style.css";
import Consents from "./consents/consents";
export function Container(props) {
    var _a;
    const content = Object.assign({}, props);
    content.title = (_a = props === null || props === void 0 ? void 0 : props.title) !== null && _a !== void 0 ? _a : "Logowanie";
    const [openedConstents, setOpenedConsents] = useState(false);
    const consents = useRef([]);
    const mainRef = useRef(null);
    const containerRef = useRef(null);
    document.title = content.title;
    return (React.createElement("div", { className: "container" },
        React.createElement("main", { ref: mainRef, className: "login" },
            React.createElement(Login, { content: content, classNames: openedConstents ? "login-not-done login-done" : "login-not-done", onSuccesfullLogin: (fetchedConsents) => {
                    consents.current = fetchedConsents;
                    setOpenedConsents(true);
                } }),
            React.createElement("div", { className: openedConstents ?
                    "consents-not-open consents-open"
                    : "consents-not-open", ref: containerRef },
                React.createElement(Consents, { consents: consents.current })))));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
